import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import ContactPage from "./pages/ContactPage";
import AccountPageRegistration from "./pages/AccountPageRegistration";
import ProfilePage from "./pages/ProfilePage";
import AboutPage from "./pages/AboutUs";
import TermsandConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CategoryPage from "./pages/CategoryPage";
import ReturnPolicy from "./pages/ReturnPolicy";
import ForgotPassword from "./pages/ForgotPassword";
import "./App.css";
import VerifyOTP from "./pages/VerifyOTP";
import ResetPassword from "./pages/ResetPassword";
import OrdersPage from "./pages/Orders";

const isAuthenticated = () => !!localStorage.getItem("accessToken");

const ProtectedRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        <Route exact path="/" element={<HomePageOne />} />
        <Route exact path="/shop/:cat_id?/:sub_cat_id?" element={<ShopPage />} />
        <Route exact path="/product-details/:id" element={<ProductDetailsPageOne />} />
        <Route exact path="/cart" element={<CartPage />} />
        <Route exact path="/checkout" element={<ProtectedRoute element={<CheckoutPage />} />} />
        <Route exact path="/category/:id" element={<CategoryPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route exact path="/login" element={<AccountPage />} />
        <Route exact path="/registration" element={<AccountPageRegistration />} />
        <Route exact path="/verify-otp" element={<VerifyOTP/>} />
        <Route exact path="/change-password" element={<ForgotPassword />} />
        <Route exact path="/reset-password" element={<ResetPassword />} />
        <Route exact path="/profile-page" element={<ProtectedRoute element={<ProfilePage />} />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/about-us" element={<AboutPage />} />
        <Route exact path="/terms-and-conditions" element={<TermsandConditions />} />
        <Route exact path="/return-policy" element={<ReturnPolicy />} />
        <Route exact path="/orders" element={<OrdersPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
